/**
 * Os usos da lista de organizações em texto, sem tela.
 *
 * O número em si sai do `shared/lib/formato`: o armazenamento com uma casa no
 * máximo ("9,3 de 10 GB"), porque duas casas num limite de 10 GB seriam
 * precisão que ninguém usa.
 */

import { comUmaCasa } from '@/shared/lib/formato';

/** "9,3 de 10 GB". */
export function rotuloDoArmazenamento(emUsoGb: number, contratadoGb: number): string {
  return `${comUmaCasa(emUsoGb)} de ${comUmaCasa(contratadoGb)} GB`;
}

/** "5 de 10". */
export function rotuloDosUsuarios(emUso: number, contratados: number): string {
  return `${emUso} de ${contratados}`;
}
